import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, finalize, map, tap, throwError } from 'rxjs';
import {
  UserAllocatedDCCS,
  UserAllocatedDCCSResponse,
} from '../../models/search-dock/dccs.model';

@Injectable({
  providedIn: 'root',
})
export class UserDccsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = 'v1/user/dccs';
  private _userAssignedDccs = signal<string | null>(null);
  userAssignedDcc = this._userAssignedDccs.asReadonly();

  // Signal to hold the result
  userAllocatedDccs = signal<{ data: UserAllocatedDCCS[] } | null>(null);
  userAllocatedDccsError = signal<Error | null>(null);
  userAllocatedDccsLoading = signal<boolean>(false);

  fetchUserAllocatedDccs(request: { email_id: string }) {
    this.userAllocatedDccsLoading.set(true);
    return this.http
      .post<UserAllocatedDCCSResponse>(this.baseUrl, request)
      .pipe(
        map((response) => ({ data: response.data || [] })),
        tap((result) => {
          this.userAllocatedDccs.set(result);
          this.userAllocatedDccsError.set(null);
        }),
        catchError((err) => {
          this.userAllocatedDccsError.set(err);
          return throwError(() => err);
        }),
        finalize(() => this.userAllocatedDccsLoading.set(false)),
      );
  }
  setUserAssignedDcc(dcc: string) {
    this._userAssignedDccs.set(dcc);
  }

  getUserAssignedDcc(): string | null {
    return this._userAssignedDccs();
  }
}
